<template>
    <div class="container">
        <loader :active="loading" />

        <header class="jumbotron">
            <div class="info">
                <div class="info-head"><font-awesome-icon icon="cog" />
                <h3>Zarządzanie grupą: <server-groups :groups="serverGroup" withName/></h3></div>
                <small>Poniżej możesz zmienić ikonkę grupy oraz jej nazwę.</small>
            </div>

            <refresh :func="refresh"/>
        </header>

        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <form name="form" @submit.prevent="saveIcon" data-vv-scope="saveIcon" enctype="multipart/form-data">
                        <div class="card-header">
                            <h5> Zarządzanie ikonką </h5>
                        </div>

                        <div class="card-body">
                            <div class="form-group">
                              <div class="custom-file">
                                <input
                                    v-validate="'required'"
                                    type="file"
                                    ref="icon"
                                    class="custom-file-input"
                                    name="icon"
                                    @change="onSelectIcon"
                                />
                                <label for="icon" class="custom-file-label" ref="iconLabel" data-browse="Wybierz">Ikonka</label>
                              </div>
                            <div
                                v-if="errors.has('saveIcon.icon')"
                                class="alert alert-danger"
                                role="alert"
                            >{{ errors.first('saveIcon.icon') }}</div>
                          </div>
                            <small>
                                Aby usunąć ikonkę, kliknij "Zapisz" bez wgranej grafiki.
                            </small>
                        </div>

                        <div class="card-footer">
                            <button class="btn btn-success" :disabled="loading">
                                <span><font-awesome-icon icon="check"/> Zapisz</span>
                            </button>
                            <button v-if="icon" class="btn btn-warning" :disabled="loading" @click.prevent="clearInput">
                                <span><font-awesome-icon icon="times"/> Wyczyść pole</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div class=" col-md-6">
                <div class="card">
                    <form name="form" @submit.prevent="saveName" data-vv-scope="saveName">
                        <div class="card-header">
                            <h5> Zarządzanie nazwą </h5>
                        </div>

                        <div class="card-body">
                            <div class="form-group">
                                <label for="groupName">Nazwa grupy</label>
                                <input
                                        v-model="groupName"
                                        v-validate="'required|min:3|max:40'"
                                        type="text"
                                        class="form-control"
                                        name="groupName"
                                />
                                <div
                                        v-if="errors.has('saveName.groupName')"
                                        class="alert alert-danger"
                                        role="alert"
                                >{{ errors.first('saveName.groupName') }}</div>
                            </div>
                        </div>

                        <div class="card-footer">
                            <button class="btn btn-success" :disabled="loading">
                                <span><font-awesome-icon icon="check"/> Zapisz</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import ManageGroupService from '../services/manageGroup.service';
    import Vue from "vue";

    export default {
        name: 'ManageGroup',
        data() {
            return {
                loading: true,
                serverGroup: {},
                groupName: "",
                icon: "",
            };
        },
        mounted() {
            this.refresh();
        },
        methods: {
            refresh() {
                this.loading = true;

                ManageGroupService.getInfo().then(
                    response => {
                        this.serverGroup = response.data;
                        this.groupName = this.serverGroup.name;
                        this.loading = false;
                    },
                    error => {
                        this.loading = false;
                        console.log(error);
                    }
                );
            },
            saveName() {
                this.loading = true;
                this.$validator.validateAll('saveName').then(isValid => {
                   if (!isValid) {
                        this.loading = false;
                        return;
                    }

                    if (this.groupName) {
                        ManageGroupService.saveGroupName(this.groupName).then(
                            () => {
                                this.refresh();
                                Vue.swal.fire({
                                    title: 'Nazwa grupy zmieniona pomyślnie!',
                                    icon: 'success',
                                    timer: 1000,
                                    showConfirmButton: false,
                                });
                            },
                            error => {
                                this.loading = false;
                                console.log(error);
                            }
                        );
                    }
                });
            },
            clearInput() {
                const input = this.$refs.icon;
                input.type = '';
                input.type = 'file';
                this.icon = "";
              this.$refs.iconLabel.innerHTML = 'Ikonka';
            },
            onSelectIcon() {
                const icon = this.$refs.icon.files[0];
                this.icon = icon;
                this.$refs.iconLabel.innerHTML = this.icon.name;
            },
            saveIcon() {
                this.loading = true;
                const formData = new FormData();
                formData.append('file', this.icon);

                ManageGroupService.saveIcon(formData).then(
                    () => {
                        this.refresh();
                        Vue.swal.fire({
                            title: 'Ikonka zmieniona pomyślnie!',
                            icon: 'success',
                            timer: 1000,
                            showConfirmButton: false,
                        });
                    },
                    error => {
                        this.loading = false;
                        console.log(error);
                    }
                )
            }

        }
    };
</script>
